import React from 'react';
import {connect} from 'react-redux';
import {GatewayGetListSchema, GatewayConnectedStatuses} from '../../../../api/DBSchema/Gateway';
import { makeStyles } from '@mui/styles';
import {connectedIcon, disabledIcon, disconnectedIcon} from '../../../../assets/images/gateway';
import {push} from 'connected-react-router';
import {SMCPaths} from '../../../../conf/Routes';
import SMCLink from '../../../Simple/SMCLink';
import SMCHighlighter from '../../../Simple/SMCHighlighter';
import { doSeamlessLogin } from '../../../../utils/utils';

function GlobalGatewaySearchItem({
    gateway,
    searchText,
    onClick,
    navigateTo,
    currentPortal
}) {
    const classes = useStyles();
    const name = gateway[GatewayGetListSchema.name];
    var portalName = gateway[GatewayGetListSchema.portalName];
    const planId = gateway[GatewayGetListSchema.planId];
    const ownerId = gateway[GatewayGetListSchema.ownerId];
    const status = gateway[GatewayGetListSchema.status];
    const description = gateway[GatewayGetListSchema.description];
    const gatewayIp = gateway[GatewayGetListSchema.gatewayIp];
    const accessGatewayEnabled = gateway[GatewayGetListSchema.accessGatewayEnabled];
    let statusIcon;
    switch (status) {
        case GatewayConnectedStatuses.connected:
            statusIcon = connectedIcon;
            break;
        case GatewayConnectedStatuses.disconnected:
            statusIcon = disconnectedIcon;
            break;
        case GatewayConnectedStatuses.disabled:
            statusIcon = disabledIcon;
            break;
        default:
            statusIcon = null;
            break;
    }

    const SearchTextHighligter = ({text}) => (
        <SMCHighlighter
            highlight={searchText}
            highlightClassName={classes.highligtedText}
            text={text}
        />
    )

    return (
        <div
            key={name}
            className={classes.resultsRowRoot}
            onMouseDown={e => e.preventDefault()}
            onClick={() => {
                if (portalName===currentPortal){
                    navigateTo(SMCPaths.gateways+'?id='+name)
                } else {
                    navigateTo(SMCPaths.relogin, {domainName: portalName,nextPage:SMCPaths.gateways+'?id='+name})
                }
                onClick && onClick();
            }}
        >
            <div className={classes.statusAndNameRoot}>
                <img src={statusIcon} className={classes.status} alt="" />
                <SearchTextHighligter text={name} />
            </div>
            <div className={classes.gatewayIp}>
            { gatewayIp && <SMCLink onClick={(e) => { doSeamlessLogin(name, 'ip'); e.stopPropagation(); }}><SearchTextHighligter text={gatewayIp} /></SMCLink> }
                { gatewayIp && accessGatewayEnabled && <>|</> }
                { accessGatewayEnabled && <SMCLink onClick={(e) => { doSeamlessLogin(name, 'reachMyDevice'); e.stopPropagation(); }}>Reach My Device</SMCLink> }
            </div>
            <span className={classes.smallText}>
                <div>
                    <SearchTextHighligter text={planId} />
                    { ownerId && <span>| <SearchTextHighligter text={ownerId} /> </span> }
                    { description && <span style={{ marginLeft: '3px' }}>| <SearchTextHighligter text={description} /></span> }
                </div>
            </span>
        </div>
    );
}


/////////////////////////////////
/* <div style="float: right;height: 20px;margin: 0px 4px 0px 0px;padding: 0px;">
    <a href="seamlesslogin.jsp?id=DFSA&amp;force_type=ip" target="_blank" class="global-search-real-link">
        <span class="match-paint" style="color:;background-color:#ffff00">1</span>72.23.54.<span class="match-paint" style="color:;background-color:#ffff00">1</span>5
    </a>
</div> */
/////////////////////////////////

const useStyles = makeStyles({
    resultsRowRoot: {
        background: '#fff',
        borderColor: '#ccc',
        borderWidth: '0 0px 1px 0px',
        borderStyle: 'solid',
        fontSize: '13px',
        height: 42,
        verticalAlign: 'middle',
        paddingTop: '2px',
        cursor: 'pointer',
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: '#E5E9ED'
        }
    },
    highligtedText: {
        backgroundColor: '#ffff00'
    },
    statusAndNameRoot: {
        float: 'left',
        margin: '-1px 0px 0px 7px',
        color: '#081936',
        fontWeight: 600
    },
    status: {
        width: '16',
        height: '16',
        position: 'relative',
        top: '4px',
        left: '-2px'
    },
    gatewayIp: {
        display: 'flex',
        float: 'right',
        height: '20px',
        margin: '0px 4px 0px 0px',
        padding: '0px'
    },
    smallText: {
        fontSize: '12px',
        color: '#777777',
        position: 'relative',
        left: '8px',
        width: '100%',
        display: 'block',
        float: 'left',
        clear: 'both',
        margin: '0 8px 0 0'
    }
});

const mapStateToProps = null;

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalGatewaySearchItem);